const BellIcon = ({ size = "12px", color = "currentColor" }: any) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 25"
      fill="none"
    >
      <g clipPath="url(#clip0_5058_5229)">
        <path
          d="M14.6416 22.5C14.4993 22.6258 14.3476 22.7417 14.1875 22.8467C13.5375 23.2728 12.7772 23.5 12 23.5C11.2228 23.5 10.4625 23.2728 9.8125 22.8467C9.6524 22.7417 9.50074 22.6258 9.3584 22.5H14.6416ZM11.4658 1.50195C13.3198 1.45539 15.1365 2.02917 16.627 3.13281C18.1172 4.23644 19.1961 5.80693 19.6924 7.59375L19.6953 7.60449L19.6992 7.61621L21.4346 13.3389C21.6158 13.9365 21.6546 14.5683 21.5479 15.1836C21.441 15.799 21.1914 16.3812 20.8193 16.8828C20.4473 17.3843 19.963 17.7915 19.4053 18.0723C18.8474 18.3531 18.231 18.5 17.6064 18.5H6.08984C5.48404 18.5 4.88567 18.3625 4.34082 18.0977C3.79605 17.8328 3.31856 17.447 2.94434 16.9707C2.57022 16.4945 2.30905 15.9395 2.18066 15.3477C2.05231 14.7558 2.0599 14.1422 2.20312 13.5537L3.55176 8.0166L3.55566 7.99902C3.96162 6.18945 4.96043 4.56672 6.39355 3.38965C7.82665 2.21266 9.61193 1.54852 11.4658 1.50195Z"
          stroke={color}
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id="clip0_5058_5229">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export default BellIcon;
